module.exports = __webpack_public_path__ + "assets/images/dbf5a520a88890d31a16a4ec3174d4f5.png";